import React from "react"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import { Container } from "@mui/material"
import Header from "./components/header"
import RecipeDetail from "./components/recipeDetail.js"
import SearchPage from "./components/search.js"
import CreatePage from "./components/create.js"
import ContactPage from "./components/contact.js"
import HomePage from "./components/home.js"

function App() {
  return (
    <Router>
      <Header />
      <Container>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/createTEMPONLYLINDADEREK" element={<CreatePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/recipe/:id" element={<RecipeDetail />} />
        </Routes>
      </Container>
    </Router>
  )
}

export default App
